const initialState = ['FIRST_SHIPMENT_RECURRING'];
const initialStateForTest = ['FIRST_SHIPMENT_RECURRING'];

export default initialState;
export { initialStateForTest };
